import React from "react";

export default function Logo({ className, style, alt = "WaveProspect", ...props }) {
  return (
    <img
      src="/images/Wave_prospect.png"
      alt={alt}
      className={className}
      style={style}
      {...props}
    />
  );
}
